
import { FocalImage } from "@/components/ui/focal-image";
import { Edit } from "lucide-react";
import type { FC, ReactNode } from "react";

export type RecipeMediaProps = Readonly<{
  imageUrl: string | null;
  title: string;
  imageHint?: string | null;
  imageFocalPointX?: number;
  imageFocalPointY?: number;
  imageZoom?: number;
  onClick?: () => void;
  canEdit?: boolean;
}>;

export const RecipeMedia: FC<RecipeMediaProps> = ({ imageUrl, title, imageHint, imageFocalPointX, imageFocalPointY, imageZoom, onClick, canEdit = false }) => {
  let mediaContent: ReactNode;

  if (!imageUrl) {
    mediaContent = (
      <div className="flex h-full items-center justify-center bg-muted">
        <span className="text-sm text-muted-foreground">No image</span>
      </div>
    );
  } else {
    mediaContent = (
      <FocalImage
        src={imageUrl}
        alt={imageHint ?? title}
        className="absolute inset-0 h-full w-full"
        data-ai-hint={imageHint ?? "recipe"}
        focalPointX={imageFocalPointX}
        focalPointY={imageFocalPointY}
        zoom={imageZoom}
      />
    );
  }

  return (
    <div className="relative aspect-video overflow-hidden rounded-lg">
      {canEdit && onClick ? (
        <button
          type="button"
          onClick={onClick}
          className="relative h-full w-full group cursor-pointer"
          aria-label="Edit recipe image"
        >
          {mediaContent}
          <div className="absolute inset-0 flex items-center justify-center bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity">
            <Edit className="h-8 w-8 text-white" />
          </div>
        </button>
      ) : (
        mediaContent
      )}
    </div>
  );
};

